export default __webpack_public_path__ + "static/media/003-facebook.1beba20a.svg";